import React from 'react';
import { summaryVFMultiSelectFieldData } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/summary-v-f-multi-select.css';


const SummaryVFMultiSelect = React.memo(({
  fieldData,
}) => {

  const {
    displayValues,
    fieldTitle,
    vFTypeSpecificOptions,
  } = fieldData;
  const {
    hideSummaryTitle,
    showSummaryAsList,
  } = vFTypeSpecificOptions;
  return (
    <div className="summary-v-f-multi-select">
      {
        !hideSummaryTitle && (
          <p className="field-title">
            {fieldTitle}
          </p>
        )
      }
      {showSummaryAsList ? (
        <ul className="field-value field-value-list">
          {displayValues.map((value) => (
            <li key={value}>
              {value}
            </li>
          ))}
        </ul>
      ) : (
        <p className="field-value">
          {displayValues.join(', ')}
        </p>
      )}
    </div>
  );
});

SummaryVFMultiSelect.propTypes = {
  fieldData: summaryVFMultiSelectFieldData,
};

export { SummaryVFMultiSelect };

